module.exports = __webpack_public_path__ + "img/ic_16_search.b6f28bc3.svg";